import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth.guard';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingPageModule)
  },
  {
    path: 'categories',
    canActivate: [authGuard],
    loadChildren: () => import('./categories/categories.module').then(m => m.CategoriesPageModule)
  },
  {
    path: 'player',
    redirectTo: '/tabs/player',
    pathMatch: 'full'
  },
  {
    path: 'pdf-viewer',
    canActivate: [authGuard],
    loadChildren: () => import('./pdf-viewer/pdf-viewer.module').then(m => m.PdfViewerPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'artist',
    loadChildren: () => import('./artist/artist.module').then(m => m.ArtistPageModule)
  },
  {
    path: 'playlist',
    loadChildren: () => import('./playlist/playlist.module').then(m => m.PlaylistPageModule)
  },
  {
    path: 'songs',
    loadChildren: () => import('./songs/songs.module').then( m => m.SongsPageModule)
  },
  {
    path: 'manage-plan',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./manage-plan/manage-plan.module').then(m => m.ManagePlanPageModule)
  },
  {
    path: 'upgrade',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./upgrade/upgrade.module').then(m => m.UpgradePageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
